import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import RegistrationForm from '../components/RegistrationForm';

const PageContainer = styled.div`
  min-height: 100vh;
  padding: 120px 20px 60px;
  background: linear-gradient(135deg, #fff7ed 0%, #fef3c7 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 100px 15px 40px;
  }
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  color: #0a2c6e;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 800;
  letter-spacing: -1px;

  span { color: #f97316; }

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 12px;
  }
`;

const SubTitle = styled.p`
  font-size: 1.1rem;
  color: #475569;
  max-width: 600px;
  text-align: center;
  margin-bottom: 36px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 28px;
  }
`;

const RegistrationNoida: React.FC = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleClose = () => {
    setFormSubmitted(true);
    setTimeout(() => {
      window.location.href = '/greater-noida';
    }, 2000);
  };

  return (
    <PageContainer>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <PageTitle>
          Summer Camp <span>2K26</span> · Greater Noida
        </PageTitle>
        <SubTitle>
          Reserve a seat for our Greater Noida edition. Robotics, AI, drone tech and aero-modelling
          — 10 days of hands-on building. Limited seats available!
        </SubTitle>
      </motion.div>

      {formSubmitted ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            background: 'white',
            padding: '30px',
            borderRadius: '15px',
            textAlign: 'center',
            maxWidth: '500px'
          }}
        >
          <h2 style={{ marginBottom: '15px', color: '#0a2c6e' }}>Thank You!</h2>
          <p style={{ color: '#475569' }}>
            Your registration is complete. Redirecting you back to the camp page...
          </p>
        </motion.div>
      ) : (
        <RegistrationForm
          onClose={handleClose}
          campName="Summer Camp 2K26 — Greater Noida"
          basePrice={4000}
        />
      )}
    </PageContainer>
  );
};

export default RegistrationNoida;
